export default __webpack_public_path__ + "static/media/sidebar-icon-company.fa697770.svg";